import React from 'react';
import { Global, css } from '@emotion/react';

import Blender from '../assets/fonts/mando/Blender-Medium.woff2';
import BlenderBold from '../assets/fonts/mando/Blender-Bold.woff2';
import BlenderThin from '../assets/fonts/mando/Blender-Thin.woff2';
import RobotoRegular from '../assets/fonts/mando/Roboto-Regular.woff2';
import RobotoSlab from '../assets/fonts/mando/RobotoSlab-Bold.woff2';
import RobotoMedium from '../assets/fonts/mando/Roboto-Medium.woff2';

const GlobalStyle = () => {
  const styles = css`

    @font-face {
      font-display: swap;
      font-family: 'Blender';
      src: url(${Blender}) format('woff2');
      font-style: normal;
      font-weight: 400;
    }

    @font-face {
      font-display: swap;
      font-family: 'BlenderBold';
      src: url(${BlenderBold}) format('woff2');
      font-style: normal;
      font-weight: 400;
    }

    @font-face {
      font-display: swap;
      font-family: 'BlenderThin';
      src: url(${BlenderThin}) format('woff2');
      font-style: normal;
      font-weight: 400;
    }

    @font-face {
      font-display: swap;
      font-family: 'Roboto';
      src: url(${RobotoRegular}) format('woff2');
      font-style: normal;
      font-weight: 400;
    }
    
    @font-face {
      font-display: swap;
      font-family: 'RobotoSlab';
      src: url(${RobotoSlab}) format('woff2');
      font-style: normal;
      font-weight: 400;
    }

    @font-face {
      font-display: swap;
      font-family: 'RobotoMedium';
      src: url(${RobotoMedium}) format('woff2');
      font-style: normal;
      font-weight: 400;
    }
  `;

  return <Global styles={styles} />;
};

export default GlobalStyle;
